import script from "./ElevateLicence.vue?vue&type=script&setup=true&lang=js"
export * from "./ElevateLicence.vue?vue&type=script&setup=true&lang=js"

import "./ElevateLicence.vue?vue&type=style&index=0&id=0cc01086&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ELA/ELA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cc01086"]])

export default __exports__